<template>
    <div class="space-y-8">
        <select-dropdown
            v-model="filterFields.locationIds"
            :auto-translate="false"
            :multiple="true"
            :searchable="true"
            :loading="fetching"
            :options="locations"
            :placeholder="$t('form.dropdown.placeholder')"
            remove-icon
            can-select-all
        >
            {{ $t('analytics.locations-filter.locations') }}
        </select-dropdown>

        <select-dropdown
            v-model="filterFields.regions"
            :auto-translate="false"
            :multiple="true"
            :searchable="true"
            :loading="fetching"
            :options="regions"
            :placeholder="$t('form.dropdown.placeholder')"
            remove-icon
            can-select-all
        >
            {{ $t('analytics.locations-filter.regions') }}
        </select-dropdown>
    </div>
</template>

<script>
import SelectDropdown from "../forms/SelectDropdown";
import Location from "../../models/Location";
import * as LocationService from '../../services/LocationService';
import {mapState} from "pinia";
import {useRepo} from 'pinia-orm';
import {useMainStore} from '../../state/store';
import {normalizeJson} from "../../../shared/helpers";

export default {
    name: 'FilterJobLocations',
    components: {
        SelectDropdown,
    },
    props: {
        filterFields: {type: Object},
    },
    computed: {
        ...mapState(useMainStore, ['locale']),
        locations() {
            let locations = useRepo(Location).all().map(val => ({
                value: val.id,
                label: val.alias && val.alias[this.locale] ? val.alias[this.locale] : `${val.street}, ${val.postal_code} ${val.city}, ${val.country}`
            }));

            // add other locations
            locations.push({
                value: 'other_locations',
                label: this.$t('analytics.filter_labels.other_locations')
            })

            // add remote
            locations.push({
                value: 'remote',
                label: this.$t('analytics.filter_labels.remote')
            })

            return locations;
        },
        regions() {
            return useRepo(Location).all().filter(val => val.region).map(val => ({
                value: val.region,
                label: val.region
            })).filter((val, index, self) => self.findIndex(t => t.value === val.value) === index);
        }
    },
    data() {
        return {
            fetching: true,
        }
    },
    mounted() {
        LocationService.index().then(({data}) => {
            useRepo(Location).save(normalizeJson(data))
        }).then(() => this.fetching = false)
    }
}
</script>
